import { useEffect, useState } from "react";
import { useContent } from "@/context/ContentContext";
import { fmtTime } from "@/lib/timings";

const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

function nowIST() {
  const p = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Kolkata", weekday: "short", hour: "2-digit", minute: "2-digit", hour12: false }).formatToParts(new Date());
  const get = (t) => p.find((x) => x.type === t)?.value;
  const day = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(get("weekday"));
  return { day, mins: (Number(get("hour")) % 24) * 60 + Number(get("minute")) };
}

export function computeStatus(schedule) {
  const { day, mins } = nowIST();
  for (const [s, e] of schedule[day] || []) {
    if (mins >= s && mins < e) return { open: true, label: "Open now", detail: `Closes at ${fmtTime(e)}`, short: `Open · till ${fmtTime(e)}` };
  }
  const later = (schedule[day] || []).find(([s]) => s > mins);
  if (later) return { open: false, label: "Currently closed", detail: `Opens today at ${fmtTime(later[0])}`, short: `Opens ${fmtTime(later[0])}` };
  for (let i = 1; i <= 7; i++) {
    const d = (day + i) % 7;
    if (schedule[d]?.length) {
      const when = i === 1 ? "tomorrow" : DAYS[d];
      return { open: false, label: "Currently closed", detail: `Opens ${when} at ${fmtTime(schedule[d][0][0])}`, short: `Opens ${when} ${fmtTime(schedule[d][0][0])}` };
    }
  }
  return { open: false, label: "Currently closed", detail: "", short: "Closed" };
}

export function useOpenStatus() {
  const { schedule } = useContent();
  const [status, setStatus] = useState(() => computeStatus(schedule));
  useEffect(() => {
    setStatus(computeStatus(schedule));
    const t = setInterval(() => setStatus(computeStatus(schedule)), 30000);
    return () => clearInterval(t);
  }, [schedule]);
  return status;
}
